import { defineStore } from "pinia"

// 顶部导航栏信息
export const useNavigationStore =  defineStore('navigationStore', {
  state: () => ({
    // 公告栏高度
    noticeHeight: 0,
    navigationHeight: '50',
    navBarDisplay: false,
    navigationTitle: '',
    navigationBgColor: '',
    navigationFontColor: '',
  }),
  getters: {},
  actions: {
    setNoticeHeight (height) {
      this.noticeHeight = height
    },
    setNavigationHeight (height) {
      this.navigationHeight = height
    },
    setNavDisplayStatus (display) {
      this.navBarDisplay = display
    },
    setNavigationTitle (title) {
      this.navigationTitle = title
    },
    setNavigationColor (bg, font) {
      this.navigationBgColor = bg
      this.navigationFontColor = font
    },
  }
})